import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import CallIcon from "@mui/icons-material/Call";
import VerifiedIcon from "@mui/icons-material/Verified";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import bgImage from "assets/images/bg-presentation.webp";

const TUTOR_HELPLINE = "09868420099";

// The old hero was a background image, an <h1> nested inside an h1-variant
// MKTypography, and a single run-on line that mixed the ISO certification
// with the phone number. Nothing asked the visitor to do anything.
function HomeHero() {
  return (
    <MKBox
      minHeight={{ xs: "88vh", md: "92vh" }}
      width="100%"
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { brand } }) =>
          `${linearGradient(rgba(brand.navyDark, 0.9), rgba(brand.navy, 0.72))}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
      }}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} lg={8}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                display: "inline-flex",
                px: 1.5,
                py: 0.75,
                mb: 2.5,
                borderRadius: 100,
                bgcolor: "rgba(255,255,255,0.14)",
                border: "1px solid rgba(255,255,255,0.22)",
              }}
            >
              <VerifiedIcon sx={{ fontSize: 17, color: "#f5a524" }} />
              <MKTypography variant="button" color="white" fontWeight="bold">
                ISO 9001:2015 certified
              </MKTypography>
            </Stack>

            <MKTypography
              variant="h1"
              color="white"
              mb={2}
              sx={({ breakpoints }) => ({
                lineHeight: 1.15,
                [breakpoints.down("md")]: { fontSize: "2rem" },
                [breakpoints.up("lg")]: { fontSize: "3.25rem" },
              })}
            >
              Home tutors your child will actually look forward to
            </MKTypography>

            <MKTypography variant="body1" color="white" opacity={0.9} mb={4} pr={{ lg: 8 }}>
              Verified, experienced teachers for every class and subject across Delhi NCR — plus A1
              Institute, A1 Play School and job placement, all under one roof.
            </MKTypography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ mb: 4 }}>
              <MKButton
                component={Link}
                to="/contact-us"
                variant="gradient"
                color="warning"
                size="large"
              >
                Find a tutor
              </MKButton>
              <MKButton
                component={Link}
                to="/tutor-registration"
                variant="outlined"
                color="white"
                size="large"
              >
                Register as a tutor
              </MKButton>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <CallIcon sx={{ fontSize: 18, color: "#fff" }} />
              <MKTypography variant="button" color="white" opacity={0.85}>
                Tutor helpline
              </MKTypography>
              <MKTypography
                component="a"
                href={`tel:${TUTOR_HELPLINE}`}
                variant="button"
                color="white"
                fontWeight="bold"
                sx={{ textDecoration: "underline" }}
              >
                {TUTOR_HELPLINE}
              </MKTypography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default HomeHero;
